import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import VerticalDraggableCards from "../components/categories.draggable.component";
import GridDraggableCards from "../components/products.draggable.component";

function ReviewScreen() {
  const [products, setProducts] = useState([]);
  const [productsAll, setProductsAll] = useState([]);
  const [categories, setCategories] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("Other");

  const { store } = useStateContext();

  const sortThem = (list, attribute) => {
    return list.sort((a, b) => {
      // Handle null values separately
      if (a[attribute] === null && b[attribute] === null) {
        return 0; // If both are null, consider them equal
      } else if (a[attribute] === null) {
        return 1; // Put null values at the end
      } else if (b[attribute] === null) {
        return -1; // Put null values at the end
      } else {
        // Compare attribute values as integers
        return a[attribute] - b[attribute];
      }
    });
  };

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    axiosClient.get(`products/${databaseStoreName}`).then((response) => {
      const sortedProducts = sortThem(response.data.data, "order");
      console.log(sortedProducts)
      const activeSortedProducts = sortedProducts.filter((obj) => obj.active == true);
      setProducts(activeSortedProducts);
      const activeSortedProductsAll = response.data.data.filter((obj) => obj.active == true);
      setProductsAll(activeSortedProductsAll)
    });

    axiosClient.get(`categories/${databaseStoreName}`).then((response) => {
      const sortedCategories = sortThem(response.data.data, "order");
      setCategories(sortedCategories);
    });
  }, [store,selectedCategory]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={3} md={3}>
        <Paper elevation={3} style={{ padding: "20px", height: "100%" }}>
          <DndProvider backend={HTML5Backend}>
            <VerticalDraggableCards
              cards={categories}
              products={products}
              productsAll={productsAll}
              setCards={setCategories}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
            />
          </DndProvider>
        </Paper>
      </Grid>
      <Grid item xs={9} md={9}>
        <Paper elevation={3} style={{ padding: "20px", height: "100%" }}>
          <DndProvider backend={HTML5Backend}>
            <GridDraggableCards
              cards={products.filter(
                (prod) => prod.Category.name === selectedCategory
              )}
              setCards={setProducts}
              products={products}
            />
          </DndProvider>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ReviewScreen;
